(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dm-requested-date')) {
    customElements.define('dm-requested-date', class extends HTMLElement {
      static values = new Map();
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.trigger = this.querySelector('[data-date-toggle]');
        this.label = this.querySelector('[data-date-label]');
        this.property = this.querySelector('input[name="properties[Wunschtermin]"]');
        this.dialog = this.querySelector('dialog');
        this.days = this.querySelector('[data-date-days]');
        this.error = this.querySelector('[data-date-error]');
        this.previous = this.querySelector('[data-date-previous]');
        this.locale = document.documentElement.lang || 'de';
        this.formatter = new Intl.DateTimeFormat(this.locale,{day:'2-digit',month:'2-digit',year:'numeric',timeZone:'UTC'});
        this.dayFormatter = new Intl.DateTimeFormat(this.locale,{weekday:'long',day:'numeric',month:'long',year:'numeric',timeZone:'UTC'});
        this.value = this.constructor.values.get(this.dataset.productId) || '';
        const week = this.querySelector('[data-date-weekdays]');
        const weekdayFormatter = new Intl.DateTimeFormat(this.locale,{weekday:'short',timeZone:'UTC'});
        week.replaceChildren(...Array.from({length:7},(_,i) => {
          const span = document.createElement('span');
          span.textContent = weekdayFormatter.format(new Date(Date.UTC(2026,0,5+i)));
          return span;
        }));
        this.trigger.addEventListener('click',() => this.open(),options);
        this.previous.addEventListener('click',() => this.shiftMonth(-1),options);
        this.querySelector('[data-date-next]').addEventListener('click',() => this.shiftMonth(1),options);
        this.querySelector('[data-date-close]').addEventListener('click',() => this.dialog.close(),options);
        this.querySelector('[data-date-clear]').addEventListener('click',() => this.select(''),options);
        this.dialog.addEventListener('close',() => {this.trigger.setAttribute('aria-expanded','false');this.trigger.focus();},options);
        this.dialog.addEventListener('click',event => {if (event.target === this.dialog) this.dialog.close();},options);
        this.days.addEventListener('click',event => {
          const button = event.target.closest('button[data-date]');
          if (button && !button.disabled) this.select(button.dataset.date);
        },options);
        this.days.addEventListener('keydown',event => {
          const button = event.target.closest('button[data-date]');
          const moves = {ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7};
          if (!button || !(event.key in moves)) return;
          event.preventDefault();
          const date = new Date(button.dataset.date+'T12:00:00Z');
          date.setUTCDate(date.getUTCDate()+moves[event.key]);
          const iso = date.toISOString().slice(0,10);
          if (iso < this.min) return;
          this.month = new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth(),1));
          this.render();
          const next = this.days.querySelector('[data-date="'+iso+'"]');
          this.days.querySelectorAll('button').forEach(item => {item.tabIndex = -1;});
          if (next) {next.tabIndex=0;next.focus();}
        },options);
        const sync = () => this.sync();
        document.addEventListener('visibilitychange',sync,options);
        window.addEventListener('pageshow',sync,options);
        const guard = event => {
          const form = event.type === 'submit' ? event.target : event.target.closest('button[type="submit"],input[type="submit"]')?.form;
          if (!form || form !== this.property.form) return;
          this.sync();
          if (this.value && this.value < this.min) {
            event.preventDefault();event.stopImmediatePropagation();this.open();
          }
        };
        document.addEventListener('submit',guard,{capture:true,signal:this.abort.signal});
        document.addEventListener('click',guard,{capture:true,signal:this.abort.signal});
        this.sync();
        this.trigger.disabled = false;
      }
      sync() {
        const parts = new Intl.DateTimeFormat('en-CA',{year:'numeric',month:'2-digit',day:'2-digit',timeZone:'Europe/Berlin'}).formatToParts(new Date());
        const part = name => Number(parts.find(item => item.type === name).value);
        this.today = new Date(Date.UTC(part('year'),part('month')-1,part('day')));
        const first = new Date(Date.UTC(part('year'),part('month')-1,part('day')+15));
        this.min = first.toISOString().slice(0,10);
        this.dataset.min = this.min;
        const invalid = Boolean(this.value && this.value < this.min);
        this.property.disabled = !this.value || invalid;
        this.property.value = this.value && !invalid ? new Intl.DateTimeFormat('de-DE',{day:'2-digit',month:'2-digit',year:'numeric',timeZone:'UTC'}).format(new Date(this.value+'T12:00:00Z')) : '';
        this.label.textContent = this.value ? this.formatter.format(new Date(this.value+'T12:00:00Z')) : this.dataset.empty;
        this.trigger.setAttribute('aria-invalid',String(invalid));
        this.error.hidden = !invalid;
        this.error.textContent = invalid ? this.dataset.invalid.replace('[date]',this.formatter.format(first)) : '';
        this.constructor.values.set(this.dataset.productId,this.value);
      }
      open() {
        this.sync();
        const date = new Date((this.value && this.value >= this.min ? this.value : this.min)+'T12:00:00Z');
        this.month = new Date(Date.UTC(date.getUTCFullYear(),date.getUTCMonth(),1));
        this.render();
        if (!this.dialog.open) this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded','true');
        (this.days.querySelector('button[aria-pressed="true"]:enabled') || this.days.querySelector('button:enabled'))?.focus();
      }
      shiftMonth(step) {
        this.sync();
        const month = new Date(Date.UTC(this.month.getUTCFullYear(),this.month.getUTCMonth()+step,1));
        const currentMonth = new Date(Date.UTC(this.today.getUTCFullYear(),this.today.getUTCMonth(),1));
        if (month < currentMonth) return;
        this.month = month;
        this.render();
      }
      render() {
        this.querySelector('[data-date-month]').textContent = new Intl.DateTimeFormat(this.locale,{month:'long',year:'numeric',timeZone:'UTC'}).format(this.month);
        const currentMonth = new Date(Date.UTC(this.today.getUTCFullYear(),this.today.getUTCMonth(),1));
        this.previous.disabled = this.month <= currentMonth;
        const fragment = document.createDocumentFragment();
        const offset = (this.month.getUTCDay()+6)%7;
        for (let i=0;i<offset;i++) fragment.append(document.createElement('span'));
        const count = new Date(Date.UTC(this.month.getUTCFullYear(),this.month.getUTCMonth()+1,0)).getUTCDate();
        let focusAssigned = false;
        const selectedInMonth = this.value && this.value.startsWith(this.month.toISOString().slice(0,7));
        for (let day=1;day<=count;day++) {
          const date = new Date(Date.UTC(this.month.getUTCFullYear(),this.month.getUTCMonth(),day));
          const iso = date.toISOString().slice(0,10);
          const button = document.createElement('button');
          button.type = 'button';button.textContent=String(day);button.dataset.date=iso;
          button.disabled = iso < this.min;
          button.setAttribute('aria-label',this.dayFormatter.format(date));
          button.setAttribute('aria-pressed',String(iso === this.value));
          button.tabIndex = !button.disabled && (iso === this.value || (!focusAssigned && !selectedInMonth)) ? 0 : -1;
          if (!button.disabled && button.tabIndex === 0) focusAssigned = true;
          fragment.append(button);
        }
        this.days.replaceChildren(fragment);
      }
      select(iso) {
        this.sync();
        if (iso && iso < this.min) return;
        this.value = iso;
        this.sync();
        this.dispatchEvent(new Event('change',{bubbles:true}));
        this.dialog.close();
      }
      disconnectedCallback() { this.abort?.abort();if (this.dialog?.open) this.dialog.close(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
